import store from '~/store'

/**
 * Redirect a user to its own profile if given user doesn't exist.
 */
export default async (to, from, next) => {
  // If user role is above recipient, proceed, otherwise, redirect.

  const user = store.getters['auth/user']

  if (user.role_id < 5) {
    next()
  } else {
    next({ name: 'settings', params: { id: user.id } })
  }
}



// WEBPACK FOOTER //
// ./resources/js/middleware/manage.js